import React from "react";
import i18n from "../../i18n/config";
import { AllocationType } from "../../types/api/allocations";

import AllocationPercentageTableRow from "./AllocationPercentageTableRow";
import { AllocationPercentageTableProps } from "../../types/components";

const AllocationPercentageTable = ({ allocations, percentValues, setPercentValues, calculate, wageAmount, totalPercent, totalFees }: AllocationPercentageTableProps) => {

  return (
    <section className="overflow-scroll width-100">
      <table className={`table old-navigator-style allocations min-w-500`}>
        <thead>
          <tr>
            <th>{i18n.t("PAGES.ALLOCATIONS.PERCENTAGE_SPLIT.TABLE.COL_HEADING_1")}</th>
            <th></th>
            <th>{i18n.t("PAGES.ALLOCATIONS.PERCENTAGE_SPLIT.TABLE.COL_HEADING_3")}</th>
            <th>{i18n.t("PAGES.ALLOCATIONS.PERCENTAGE_SPLIT.TABLE.COL_HEADING_4")}</th>
            <th>{i18n.t("PAGES.ALLOCATIONS.PERCENTAGE_SPLIT.TABLE.COL_HEADING_5")}</th>
          </tr>
        </thead>
        <tbody>
          {allocations.map((allocation: AllocationType) => {
            return (
              <AllocationPercentageTableRow
                key={allocation.id}
                allocation={allocation}
                percentValues={percentValues}
                setPercentValues={setPercentValues}
                calculate={calculate}
                wageAmount={wageAmount}
              />
            )
          })}

          <tr>
            <td className="bold">{i18n.t("COMMON.TOTAL")}: </td>
            <td></td>
            <td>{totalFees}</td>
            <td>{totalPercent}%</td>
            <td></td>
          </tr>

        </tbody>
      </table>
    </section>
  );
}

export default AllocationPercentageTable;